import { ConfigClass } from '../common/config.class';
import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';

export class Cache {
  public readonly Excludes: string[];

  constructor(...excludes: string[]) {
    this.Excludes = excludes || [];
  }
}

@Injectable()
export class AppConfig {

  public static SupportedLanguages = [
    { name: 'Magyar', value: 'hu' },
    { name: 'Angol', value: 'en' },
  ];

  private cache: Cache;

  public get Cache() {
    try {
      return this.cache || (this.cache = new Cache(this.config.identityServerAddress));
    } catch (error) {
      return new Cache();
    }
  }

  public get IMSConfig(): ConfigClass { return { url: this.config.identityServerAddress + '/api', mode: 'Dev' }; }
  public get OMSConfig(): ConfigClass { return { url: this.config.organizationManagementAddress + '/api', mode: 'Dev' }; }
  public get PMSConfig(): ConfigClass { return { url: this.config.profileManagementAddress + '/api', mode: 'Dev' }; }
  public get UMSConfig(): ConfigClass { return { url: this.config.userManagementAddress + '/api', mode: 'Dev' }; }
  public get RMSConfig(): ConfigClass { return { url: this.config.roleManagementAddress + '/api', mode: 'Dev' }; }
  public get AMSConfig(): ConfigClass { return { url: this.config.assignmentManagementAddress + '/api', mode: 'Dev' }; }
  public get LMSConfig(): ConfigClass { return { url: this.config.labelManagementAddress + '/api', mode: 'Dev' }; }
  public get FMSConfig(): ConfigClass { return { url: this.config.formManagementAddress + '/api', mode: 'Dev' }; }
  public get FPMSConfig(): ConfigClass { return { url: this.config.formManagementAddress + '/api', mode: 'Dev' }; }
  public get CLMSConfig(): ConfigClass { return { url: this.config.codeListManagementAddress + '/api', mode: 'Dev' }; }
  public get DEMSConfig(): ConfigClass { return { url: this.config.dataEntryManagementAddress + '/api', mode: 'Dev' }; }
  public get DEFMSConfig(): ConfigClass { return { url: this.config.dataEntryManagementAddress + '/api', mode: 'Dev' }; }
  public get DERMSConfig(): ConfigClass { return { url: this.config.dataEntryManagementAddress + '/api', mode: 'Dev' }; }
  public get DEMMSConfig(): ConfigClass { return { url: this.config.dataEntryManagementAddress + '/api', mode: 'Dev' }; }
  public get DEAMSConfig(): ConfigClass { return { url: this.config.dataEntryManagementAddress + '/api', mode: 'Dev' }; }
  public get IMMSConfig(): ConfigClass { return { url: this.config.internalMessageManagementAddress + '/api', mode: 'Dev' }; }
  public get MMMSConfig(): ConfigClass { return { url: this.config.maintenanceMessageManagementAddress + '/api', mode: 'Dev' }; }
  public get PMMSConfig(): ConfigClass { return { url: this.config.portalMessageManagementAddress + '/api', mode: 'Dev' }; }
  public get HMMSConfig(): ConfigClass { return { url: this.config.helpMessageManagementAddress + '/api', mode: 'Dev' }; }
  public get CMSConfig(): ConfigClass { return { url: this.config.changeManagementAddress + '/api', mode: 'Dev' }; }
  public get WMSConfig(): ConfigClass { return { url: this.config.workflowManagementAddress + '/api', mode: 'Dev' }; }
  public get CAMSConfig(): ConfigClass { return { url: this.config.caseManagementAddress + '/api', mode: 'Dev' }; }
  public get KPIConfig(): ConfigClass { return { url: this.config.kpiManagementAddress + '/api', mode: 'Dev' }; }
  public get BMSConfig(): ConfigClass { return { url: this.config.bulletinManagementAddress + '/api', mode: 'Dev' }; }
  public get FMMSConfig(): ConfigClass { return { url: this.config.faqMessageManagementAddress + '/api', mode: 'Dev' }; }
  public get VMSConfig(): ConfigClass { return { url: this.config.validationManagementAddress + '/api', mode: 'Dev' }; }
  public get BTMSConfig(): ConfigClass { return { url: this.config.batchManagementAddress + '/api', mode: 'Dev' }; }
  public get NMSConfig(): ConfigClass { return { url: this.config.notificationManagementAddress + '/api', mode: 'Dev' }; }
  public get CPMSConfig(): ConfigClass { return { url: this.config.customPropManagementAddress + '/api', mode: 'Dev' }; }
  public get OAMSConfig(): ConfigClass { return { url: this.config.officialActManagementAddress + '/api', mode: 'Dev' }; }
  public get INMSConfig(): ConfigClass { return { url: this.config.inspectionManagementAddress + '/api', mode: 'Dev' }; }
  public get BFFSConfig(): ConfigClass { return { url: this.config.backendForFrontendAddress + '/api', mode: 'Dev' }; }
  public get SGMSConfig(): ConfigClass { return { url: this.config.secGroupManagementAddress + '/api', mode: 'Dev' }; }
  public get UNMSConfig(): ConfigClass { return { url: this.config.universalModuleAddress + '/api', mode: 'Dev' }; }

  constructor(private config: ConfigurationService) { }
}



// WEBPACK FOOTER //
// ./src/app/configuration/app.config.ts